import { Component } from '@angular/core';
@Component({
  selector: 'app-confirmed',
  templateUrl: './app.unconfirmed.component.html',
  styleUrls: ['./app.unconfirmed.component.scss']
})
export class AppUnconfirmedComponent {
  constructor() {

  }
  async redirectToLogin() {
    window.location.href = '/login';
  }
}
